// Component 1: Authentication & User Management
// Auth context, provider, token manager, and hook

import AuthContext from './context';
import AuthProvider from './provider.jsx';
import { useAuth } from './hooks';
import AuthTokenManager from './TokenManager';
import LoginForm from './components/LoginForm.jsx';
import RegisterForm from './components/RegisterForm.jsx';
import RegisterPage from './components/RegisterPage.jsx';
import ForgotPasswordForm from './components/ForgotPasswordForm.jsx';
import ForgotPasswordPage from './components/ForgotPasswordPage.jsx';
import ResetPasswordForm from './components/ResetPasswordForm.jsx';
import ResetPasswordPage from './components/ResetPasswordPage.jsx';
import ChangePasswordForm from './components/ChangePasswordForm.jsx';
import ChangePasswordPage from './components/ChangePasswordPage.jsx';
import RouteGuards from './components/RouteGuards.jsx';
import SessionConflictNotification from './components/SessionConflictNotification.jsx';
import ProfilePage from './components/ProfilePage.jsx';
import * as TokenTestUtils from './utils/TokenTestUtils.js';

export { 
  AuthContext, 
  AuthProvider, 
  useAuth, 
  AuthTokenManager, 
  LoginForm, 
  RegisterForm, 
  RegisterPage,
  ForgotPasswordForm,
  ForgotPasswordPage,
  ResetPasswordForm,
  ResetPasswordPage,
  ChangePasswordForm,
  ChangePasswordPage,
  SessionConflictNotification,
  ProfilePage
};

// Export route guards
export const {
  ProtectedRoute,
  PublicOnlyRoute,
  RoleGuard,
  AdminRoute,
  SuperAdminRoute,
  SubscriptionRoute,
  LoadingSpinner,
  ErrorBoundary
} = RouteGuards;

// Export test utilities (development only)
export { TokenTestUtils };

export const AUTH_MODULE_STATUS = 'READY_CONTEXT';

